import { NavLink } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import React, { useEffect } from "react";
import useTranslation from "../../i18n/useTranslation";

export default function SuccessPage() {
    const { t } = useTranslation();

    useEffect(() => {
        const prevTitle = document.title;
        document.title = t("successPage.meta.title");

        return () => {
            document.title = prevTitle;
        };
    }, [t]);

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflowX: "hidden",
                padding: 20,
            }}
        >
            <div
                style={{
                    backgroundColor: "#1f1f2e",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
                    textAlign: "center",
                    maxWidth: "450px",
                    width: "100%",
                }}
            >
                {/* Logo */}
                <div className="mb-3">
                    <NavLink to="/">
                        <img
                            src="/dist/img/angeonx-sports.png"
                            alt={t("successPage.brand.logoAlt")}
                            className="logo img-fluid"
                            style={{ height: "80px", marginBottom: "10px" }}
                        />
                    </NavLink>

                    <h2
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "var(--kbs-primary, #00adff)",
                        }}
                    >
                        {t("successPage.brand.namePrimary")}{" "}
                        <span style={{ color: "#ffffff" }}>
                            {t("successPage.brand.nameSecondary")}
                        </span>
                    </h2>
                </div>

                <h3
                    className="mb-3"
                    style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                    }}
                >
                    {t("successPage.content.title")}
                </h3>

                <p>
                    <FaCheckCircle size={50} color="var(--kbs-primary, #00adff)" />
                </p>

                <p
                    className="mt-3"
                    style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#f1f2f5",
                    }}
                >
                    {t("successPage.content.description")}
                </p>
            </div>
        </div>
    );
}
